module.exports = __webpack_public_path__ + "img/exclemation-mark-gray.4e5982be.svg";